//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.Mlp.js";
import "../no/Object.js";
import "../no/BasePart.js";
import "../no/Session.js";
let d=[[],[[["part"],"GetProcessPlan",{R_:{process_plan:"Mfg.Mlp.ProcessPlan"}},1,0],[["command_id"],"CreateCommand",{R_:{command:"Mfg.Mlp.Command"}},1,0]],[]];
SPLM.Mfg.Mlp.MachiningLinePlanner = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.Mlp.MachiningLinePlanner";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;